module.exports = __webpack_public_path__ + "img/avatar2.eac85196.png";